export const notificationStatusDTO = {
  seen: true,
  unseen: false,
};

export const notificationStatusRequest = {
  seen: '1',
  unseen: '0',
};
